import { BaseEdge, EdgeToolbar, getBezierPath, type EdgeProps } from '@xyflow/react'
import { Symbol } from '../../../ui'
import { useAutomationEditor } from '../editor-context'

export function EditableEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
}: EdgeProps) {
  const { disconnectEdge } = useAutomationEditor()
  const [path, centerX, centerY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  })

  return (
    <>
      <BaseEdge id={id} path={path} />
      <EdgeToolbar edgeId={id} x={centerX} y={centerY} isVisible>
        <button
          type="button"
          className="nodrag nopan editor-edge__delete"
          onClick={(event) => {
            event.stopPropagation()
            disconnectEdge(id)
          }}
          title="Verbindung entfernen"
          aria-label="Verbindung entfernen"
        >
          <Symbol name="close" width={14} height={14} />
        </button>
      </EdgeToolbar>
    </>
  )
}
